import { OrderBaseView } from "../../../order/base";
import { Template } from "../../../../../../core/template/index";
import { FortumApp } from "../../../../../fortumApp";
import { View } from "../../../../../../core/view/index";
import { OrderLike, Order } from "../../../../../db/models/decontamination/order";
import { OrderItemLike, OrderItem } from "../../../../../db/models/decontamination/orderItem";
import { OrderDetailViewData } from "../../detail/index";
import ConfirmModal from "../../../../../../core/modals/confirm/index";
import { ClientAction } from "../../../../../synchronizer/index";
import MessageModal from "../../../../../../core/modals/message/index";
import { ModalColor } from "../../../../../../core/modal/index";

export default class OrderOverviewTabView extends View
{
    public template = Template.lazy('/app/views/decontamination/order/tab/overview/index.html');
    public app: FortumApp;
    public data: OrderOverviewTabData;

    constructor(data?: OrderOverviewTabData) 
    {
        super(data);
    }

    public beforeRender(): PromiseLike<void>
    {        
        this.data.stateLabels = {
            [Order.STATE_NEW]: this.pgettext('decontamination.Order.state', 'New'),
            [Order.STATE_STARTED]: this.pgettext('decontamination.Order.state', 'Started'),
            [Order.STATE_COMPLETED]: this.pgettext('decontamination.Order.state', 'Completed'),
        }
        return super.beforeRender();
    }

    public afterRender(): PromiseLike<void>
    {        
        return super.afterRender();
    }

    private onSetCompletedButtonClick(e: MouseEvent, sender: HTMLButtonElement)
    {
        if (!this.data.isValid)
        {
            this.app.modals.show(new MessageModal({
                color: ModalColor.RED,
                message: this.pgettext(
                    'decontamination.Order', 
                    'This order cannot be marked as completed because one or more of the items are not completed.'
                )
            }));
            return;
        }
        this.helpers.setButtonEnabled(sender, false);
        const done = () => {
            this.helpers.setButtonEnabled(sender, true);
        };

        new ConfirmModal({
            message: this.pgettext(
                'decontamination.message',
                'Are you sure you want to mark this order as completed?'
            )
        }).prompt().then((confirmed) => {
            if (!confirmed) {
                done();
                return;
            }
            
            return Order.complete(this.app, this.data.order.id).then(() => {
                this.app.refreshCurrentView({tab: 'overview'}).then(() => {
                    this.app.toasts.show(this.app.pgettext(
                        'decontamination.message',
                        'Successfully marked as completed!'
                    ));
                })
            }, () => {
                done();
            });
        });
    }
}

export interface OrderOverviewTabData extends OrderDetailViewData
{
    stateLabels?: {[key: string]: string};
}